// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"45f4c3e9","455":"d388ec8b","977":"3801b78d"}[chunkId] + ".chunk.js";
};